import { type Registry as Services, service } from '@ember/service';
import ApplicationAdapter from 'lumen/adapters/application';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class FavouriteCurrencyAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  namespace = APIGATEWAY;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForCreateRecord() {
    const userId = this.hotelAndMarketService.user?.id;
    return `${this.host}/${this.namespace}/users/${userId}/favourite-currencies`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForDeleteRecord(id: string) {
    const userId = this.hotelAndMarketService.user?.id;
    return `${this.host}/${this.namespace}/users/${userId}/favourite-currencies/${id}`;
  }
}
